import React, { Component, cloneElement, useState } from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  BooleanField,
  SelectInput,
  GET_ONE,
  useRecordContext,
  useResourceContext,
  required,
  FunctionField,
  NumberInput
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Spinner from "../spinner";
import myDataProvider from "../myRestProvider";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  getLocalStorageKey,
} from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const ClickItUserFilter = (props) => {
  let locale = getLocalStorageKey("locale");
  
  return(
  <Filter {...props}>
    <ReferenceInput
      label="Sold To Name"
      source="business_id"
      reference="businesses"
      linkType="show"
      allowEmpty
    >
      <AutocompleteInput optionText="name" label="Sold To Name" />
    </ReferenceInput>
    <TextInput source="first_name" />
    <TextInput source="last_name" />
    {/* <TextInput source="ship_to_sap_number" label="Ship To ID" /> */}
    <NumberInput source="phone" min='0'  />
    <TextInput source="email" />
    <SelectInput
      source="status"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
      validate={required()}
    />
   {locale == "ar-EG" && <SelectInput
      source="is_payment_enable"
      choices={[
        { id: true, name: "True" },
        { id: false, name: "False" },
      ]}
      label='Payment available'
      validate={required()}
    />}
  </Filter>
)};

const CustomShowButton = () => {
  const record = useRecordContext();
  const resource = useResourceContext();
  console.log("record customeShow", record);
  console.log("resource customeShow", resource);
  return (
    <div>
      <ShowButton to={`${record?.user_id}/show`} />
    </div>
  );
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();
  const [modalShow, setModalShow] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const [customFilterUrl, setCustomFilterUrl] = useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location.pathname.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          //   this.setState({ modalShow: true});
          //   this.setState({ modalMsg: msg});
        });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
          //   this.setState({ modalShow: true});
          //   this.setState({ modalMsg: msg});
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <React.Fragment>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <RefreshButton />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </React.Fragment>
  );
};

const ClickItUserList = (props) => {
  let locale = getLocalStorageKey("locale");
  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          // {...props}
          // exporter={this.exporter}
          sort={{ field: "created_at", order: "DESC" }}
          filters={<ClickItUserFilter />}
          title="User List"
          actions={<ListActions permissions={props} />}
        >
          <Datagrid bulkActionButtons={false}>
            <TextField label="First name" source="first_name" style={{textTransform:"capitalize"}}
 />
            <TextField label="Last name" source="last_name"  style={{textTransform:"capitalize"}}/>
            <TextField source="phone" sortable={false} allowEmpty />
            <TextField label="Email" source="email" allowEmpty />
            <ReferenceField
              label="Sold To Name"
              source="principle_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField
              label="Sold To ID"
              source="principle_id"
              reference="businesses"
              link="show"
              allowEmpty
            >
              <TextField source="sap_code" />
            </ReferenceField>
            <FunctionField label="Role name"render={record => record ?record["role_name"].includes("_")? record["role_name"].split("_")[0]+" "+record["role_name"].split("_")[1]:record["role_name"] : null}  style={{textTransform:"capitalize"}} />
            <DateField label={"Created at"} source="created_at" allowEmpty />
            <BooleanField source="status" />
            {locale == "ar-EG" && <BooleanField source="is_payment_enable" label='Payment available' />}
            <CustomShowButton />
          </Datagrid>
        </List>
      </Scrollbars>
    </React.Fragment>
  );
};

export default ClickItUserList;
